import { useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogDescription,
} from '../../ui/dialog';
import { Button } from '../../ui/button';

interface CaseSaveCommentDialogProps {
    open: boolean;
    isComplete: boolean;
    commentRequired: boolean;
    onConfirm: (comment?: string) => void;
    onCancel: () => void;
}

export function CaseSaveCommentDialog({
    open,
    isComplete,
    commentRequired,
    onConfirm,
    onCancel,
}: CaseSaveCommentDialogProps) {
    const [comment, setComment] = useState('');

    const trimmed = comment.trim();
    const canConfirm = !commentRequired || trimmed.length > 0;

    const handleConfirm = () => {
        onConfirm(trimmed || undefined);
        setComment('');
    };

    const handleCancel = () => {
        setComment('');
        onCancel();
    };

    return (
        <Dialog open={open} onOpenChange={(open) => !open && handleCancel()}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>
                        {isComplete
                            ? 'Complete Case Report'
                            : 'Save Draft'}
                    </DialogTitle>
                    <DialogDescription>
                        {commentRequired
                            ? 'A comment is required when editing a completed report.'
                            : 'Optionally add a comment describing your changes.'}
                    </DialogDescription>
                </DialogHeader>
                <textarea
                    placeholder={
                        commentRequired
                            ? 'Describe what was changed…'
                            : 'Add a comment (optional)…'
                    }
                    value={comment}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                        setComment(e.target.value)
                    }
                    rows={3}
                    className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring resize-none"
                />
                <DialogFooter>
                    <Button variant="outline" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} disabled={!canConfirm}>
                        {isComplete ? 'Complete' : 'Save Draft'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
